import { useQuery, UseQueryResult } from 'react-query';

import { getTokenWithType } from './useAuth';

import {
  getQuestionSpecifications,
  getQuestionSpecificationsForLookup,
} from '../utils/urls';

import { QuestionSpecificationType } from 'types/questions';
import { ErrorModal } from 'types/modalTypes';

async function fetchQuestionSpecifications({
  questionTypeName,
}: TVariables): Promise<APIResult> {
  const response = await fetch(
    questionTypeName === 'lookup'
      ? getQuestionSpecificationsForLookup(questionTypeName.toLowerCase())
      : getQuestionSpecifications(questionTypeName?.toLowerCase()),
    {
      method: 'GET',
      headers: {
        Authorization: getTokenWithType(),
      },
    },
  );
  return response.json();
}

type TError = ErrorModal;

type APIResult = {
  Data: QuestionSpecificationType | undefined;
  IsSuccess: boolean;
  StatusCode: number;
};

type TResult = QuestionSpecificationType | undefined;

type TVariables = {
  questionTypeName: string | undefined;
};

function useGetQuestionSpecifications(
  questionTypeName: string | undefined,
): UseQueryResult<TResult, TError> {
  return useQuery(
    ['get_question_spec', questionTypeName],
    async () => {
      if (questionTypeName) {
        const response = await fetchQuestionSpecifications({
          questionTypeName,
        });
        return response.Data;
      }
    },
    {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
    },
  );
}

export { useGetQuestionSpecifications };
